// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_dhDMc mb-1.25 text-sm","name":"name_YibVr !text-black underline md_!text-blue-dark md_no-underline md_hover_underline"};